module.exports = Object.freeze({
    NONE: 0,                // none
    DELETED: 1,             // reserved
    SUSPENDED: 2,           // (about coordinator)
    REFUSED: 3,             // (by "child")
    REJECTED: 4,            // (by "parent")
    INSERTED: 5,            // (by "parent")
    REQUESTED: 6,           // (by "child")
    CONFIRMED: 7,           // (by "child")
    ACCEPTED: 8,            // (by "parent")
    COMPLETED: 9            // (by "parent")
});